"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateListingDtoSaleTypeEnum = exports.CreateListingDtoLandAreaUnitEnum = exports.CreateListingDtoPropertyCategoryEnum = void 0;
exports.instanceOfCreateListingDto = instanceOfCreateListingDto;
exports.CreateListingDtoFromJSON = CreateListingDtoFromJSON;
exports.CreateListingDtoFromJSONTyped = CreateListingDtoFromJSONTyped;
exports.CreateListingDtoToJSON = CreateListingDtoToJSON;
exports.CreateListingDtoToJSONTyped = CreateListingDtoToJSONTyped;
var LovableExtrasDto_1 = require("./LovableExtrasDto");
var OpenInspections_1 = require("./OpenInspections");
var PropertyTypeInput_1 = require("./PropertyTypeInput");
var Enhancements_1 = require("./Enhancements");
var PropertyAddressInput_1 = require("./PropertyAddressInput");
/**
 * @export
 */
exports.CreateListingDtoPropertyCategoryEnum = {
    Residential: 'residential',
    Rural: 'rural',
    Land: 'land'
};
/**
 * @export
 */
exports.CreateListingDtoLandAreaUnitEnum = {
    Sqm: 'sqm',
    Acre: 'acre',
    Hectare: 'hectare'
};
/**
 * @export
 */
exports.CreateListingDtoSaleTypeEnum = {
    PrivateSale: 'private_sale',
    Auction: 'auction'
};
/**
 * Check if a given object implements the CreateListingDto interface.
 */
function instanceOfCreateListingDto(value) {
    if (!('propertyCategory' in value) || value['propertyCategory'] === undefined)
        return false;
    if (!('propertyType' in value) || value['propertyType'] === undefined)
        return false;
    if (!('address' in value) || value['address'] === undefined)
        return false;
    if (!('showStreetAddress' in value) || value['showStreetAddress'] === undefined)
        return false;
    if (!('price' in value) || value['price'] === undefined)
        return false;
    if (!('saleType' in value) || value['saleType'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('description' in value) || value['description'] === undefined)
        return false;
    if (!('contactName' in value) || value['contactName'] === undefined)
        return false;
    if (!('contactPhone' in value) || value['contactPhone'] === undefined)
        return false;
    if (!('contactEmail' in value) || value['contactEmail'] === undefined)
        return false;
    if (!('publishTimestamp' in value) || value['publishTimestamp'] === undefined)
        return false;
    return true;
}
function CreateListingDtoFromJSON(json) {
    return CreateListingDtoFromJSONTyped(json, false);
}
function CreateListingDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'propertyCategory': json['propertyCategory'],
        'propertyType': (0, PropertyTypeInput_1.PropertyTypeInputFromJSON)(json['propertyType']),
        'address': (0, PropertyAddressInput_1.PropertyAddressInputFromJSON)(json['address']),
        'showStreetAddress': json['showStreetAddress'],
        'landArea': json['landArea'] == null ? undefined : json['landArea'],
        'landAreaUnit': json['landAreaUnit'] == null ? undefined : json['landAreaUnit'],
        'floorAreaInSqm': json['floorAreaInSqm'] == null ? undefined : json['floorAreaInSqm'],
        'frontageInMeters': json['frontageInMeters'] == null ? undefined : json['frontageInMeters'],
        'isNewProperty': json['isNewProperty'] == null ? undefined : json['isNewProperty'],
        'housePackageType': json['housePackageType'] == null ? undefined : json['housePackageType'],
        'bedrooms': json['bedrooms'] == null ? undefined : json['bedrooms'],
        'bathrooms': json['bathrooms'] == null ? undefined : json['bathrooms'],
        'ensuites': json['ensuites'] == null ? undefined : json['ensuites'],
        'toilets': json['toilets'] == null ? undefined : json['toilets'],
        'carports': json['carports'] == null ? undefined : json['carports'],
        'openParkingSpaces': json['openParkingSpaces'] == null ? undefined : json['openParkingSpaces'],
        'garages': json['garages'] == null ? undefined : json['garages'],
        'energyRating': json['energyRating'] == null ? undefined : json['energyRating'],
        'yearBuilt': json['yearBuilt'] == null ? undefined : json['yearBuilt'],
        'zoning': json['zoning'] == null ? undefined : json['zoning'],
        'amenities': json['amenities'] == null ? undefined : json['amenities'],
        'price': json['price'],
        'saleType': json['saleType'],
        'auctionStartDate': json['auctionStartDate'] == null ? undefined : json['auctionStartDate'],
        'ownershipDocsUrls': json['ownershipDocsUrls'] == null ? undefined : json['ownershipDocsUrls'],
        'ownerPhotoIdUrls': json['ownerPhotoIdUrls'] == null ? undefined : json['ownerPhotoIdUrls'],
        'title': json['title'],
        'description': json['description'],
        'contactName': json['contactName'],
        'contactPhone': json['contactPhone'],
        'contactEmail': json['contactEmail'],
        'mediaUrls': json['mediaUrls'] == null ? undefined : json['mediaUrls'],
        'videoUrl': json['videoUrl'] == null ? undefined : json['videoUrl'],
        'floorPlansUrls': json['floorPlansUrls'] == null ? undefined : json['floorPlansUrls'],
        'openInspections': json['openInspections'] == null ? undefined : (json['openInspections'].map(OpenInspections_1.OpenInspectionsFromJSON)),
        'Enhancements': json['Enhancements'] == null ? undefined : (json['Enhancements'].map(Enhancements_1.EnhancementsFromJSON)),
        'publishTimestamp': json['publishTimestamp'],
        'lovableExtras': json['lovableExtras'] == null ? undefined : (0, LovableExtrasDto_1.LovableExtrasDtoFromJSON)(json['lovableExtras']),
    };
}
function CreateListingDtoToJSON(json) {
    return CreateListingDtoToJSONTyped(json, false);
}
function CreateListingDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'propertyCategory': value['propertyCategory'],
        'propertyType': (0, PropertyTypeInput_1.PropertyTypeInputToJSON)(value['propertyType']),
        'address': (0, PropertyAddressInput_1.PropertyAddressInputToJSON)(value['address']),
        'showStreetAddress': value['showStreetAddress'],
        'landArea': value['landArea'],
        'landAreaUnit': value['landAreaUnit'],
        'floorAreaInSqm': value['floorAreaInSqm'],
        'frontageInMeters': value['frontageInMeters'],
        'isNewProperty': value['isNewProperty'],
        'housePackageType': value['housePackageType'],
        'bedrooms': value['bedrooms'],
        'bathrooms': value['bathrooms'],
        'ensuites': value['ensuites'],
        'toilets': value['toilets'],
        'carports': value['carports'],
        'openParkingSpaces': value['openParkingSpaces'],
        'garages': value['garages'],
        'energyRating': value['energyRating'],
        'yearBuilt': value['yearBuilt'],
        'zoning': value['zoning'],
        'amenities': value['amenities'],
        'price': value['price'],
        'saleType': value['saleType'],
        'auctionStartDate': value['auctionStartDate'],
        'ownershipDocsUrls': value['ownershipDocsUrls'],
        'ownerPhotoIdUrls': value['ownerPhotoIdUrls'],
        'title': value['title'],
        'description': value['description'],
        'contactName': value['contactName'],
        'contactPhone': value['contactPhone'],
        'contactEmail': value['contactEmail'],
        'mediaUrls': value['mediaUrls'],
        'videoUrl': value['videoUrl'],
        'floorPlansUrls': value['floorPlansUrls'],
        'openInspections': value['openInspections'] == null ? undefined : (value['openInspections'].map(OpenInspections_1.OpenInspectionsToJSON)),
        'Enhancements': value['Enhancements'] == null ? undefined : (value['Enhancements'].map(Enhancements_1.EnhancementsToJSON)),
        'publishTimestamp': value['publishTimestamp'],
        'lovableExtras': (0, LovableExtrasDto_1.LovableExtrasDtoToJSON)(value['lovableExtras']),
    };
}
